import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'


import Body from 'components/typography/body2/index'

import styles from './styles.scss'

const EmptyMessage = () => {
  return (
      <div className={styles.placeholder}>
        {'There are currently no NVQual submissions.'}
      </div>
  )
}

export default CSSModules(styles)(EmptyMessage)
